import { Component, OnInit, EventEmitter } from '@angular/core';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import {FieldDefinition} from '@shared/models/field-definition';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';

@Component({
    standalone: false,
    selector: 'particle-manage-cell-viewer',
  templateUrl: './manage-cell-viewer.component.html',
  styleUrls: ['./manage-cell-viewer.component.scss']
})
export class ManageCellViewerComponent implements OnInit, CellComponent {
  sourceType?: string;
  valueChanged?: EventEmitter<any>;
  invalidateSubject?: InvalidateSubject;
  item: any;
  fieldDefinition: FieldDefinition;
  displayText: string;
  value: any;
  disabled: boolean;

  constructor() { }

  ngOnInit() {
  }

  manage() {

  }

}
